import { createContext } from 'react';

import type { PaymentMethodsStore } from '.';

export const StoreContext = createContext<PaymentMethodsStore | null>(null);
